// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1wwq1","Label":"Input_Label__3WsqC","InputElement":"Input_InputElement__yHm1-","Invalid":"Input_Invalid__2VhgR"};